module.exports = __webpack_public_path__ + "img/entry-preview.bc047bc8.png";